
import {Component, Input, OnInit ,Output, EventEmitter} from '@angular/core';


@Component({
  selector: 'radio-checkbox-dropdown-type',
  templateUrl: './radio-checkbox-dropdown-type.component.html',
  styleUrls: ['./radio-checkbox-dropdown-type.component.css']
})
export class RadioCheckboxDropdownTypeComponent implements OnInit{

  @Input() heading : string;
  glyphiconForHeading : string;
  @Output() primaryQuestionEntered = new EventEmitter<string>();
  @Output() secondaryQuestionEntered = new EventEmitter<string>();
  @Output() isRequiredChanged = new EventEmitter<boolean>();
  @Output() addOptionsClickedEvent = new EventEmitter();

  ngOnInit() : void{

    switch (this.heading){
      case 'Radio':{
        this.heading = "Radio Input";
        this.glyphiconForHeading = "glyphicon glyphicon-record";
        break;
      }
      case 'Checkbox':{
        this.heading = "Check Box";
        this.glyphiconForHeading = "glyphicon glyphicon-check";
        break;
      }
      case 'Selected Dropdown':{
        this.heading = "Drop Down";
        this.glyphiconForHeading = "glyphicon glyphicon-triangle-bottom";
        break;
      }
    }

  }


  questionPrimaryEnter(event : any){
    this.primaryQuestionEntered.emit(event.target.value);
  }

  questionSecondaryEnter(event : any){
    this.secondaryQuestionEntered.emit(event.target.value);
  }

  requiredChanged(event : boolean){

    this.isRequiredChanged.emit(event);
  }

  addOptionsClicked(){
    this.addOptionsClickedEvent.emit();
  }

  questionTypeSelected(type){

  }

}



// WEBPACK FOOTER //
// ./src/app/oldCentralPannel/radio-checkbox-dropdown-type/radio-checkbox-dropdown-type.component.ts